export default __webpack_public_path__ + "static/media/botao-google-app.3d5cc464.png";